import * as React from "react";
import "./EpisodeListViewStyles.css";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../../utils/Helpers";
import { MoviePoster } from "../movie/MoviePoster";
export var EpisodeListItemView = function (_a) {
    var episode = _a.episode, isComingSoon = _a.isComingSoon, onEpisodePress = _a.onEpisodePress, isCurrentEpisode = _a.isCurrentEpisode, focusRaw = _a.focusRaw, onClose = _a.onClose;
    var t = useTranslation().t;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onEpisodePress(episode); },
        onKeyBack: onClose,
    });
    return (React.createElement("div", { id: "episode-" + episode.id, className: "episode-item-container" },
        React.createElement("div", { ref: ref, tabIndex: 0, className: "episode-item" },
            React.createElement(MoviePoster, { url: episode.thumbnail, className: "episode-item-img" }),
            isComingSoon && (React.createElement("div", { className: "coming-soon-episode" },
                React.createElement("p", null, t("layout.coming_soon")))),
            isCurrentEpisode ? (React.createElement("p", { className: "episode-current" }, t("movie.currently_playing"))) : null,
            episode.watchHistory ? (React.createElement("div", { className: "progress-container" },
                React.createElement("div", { className: "progress-box" },
                    React.createElement("div", { className: "bar", style: "width: " + (episode.watchHistory.progress > 0.05
                            ? episode.watchHistory.progress * 100
                            : 5) + "%" })))) : null),
        React.createElement("div", { className: "details-container" },
            React.createElement("p", { className: "episode-number" },
                t("movie.episode"),
                " ",
                episode.episodeNumber),
            React.createElement("p", { className: "episode-name" }, episode.name))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/episode-list/EpisodeListItemView.tsx
// module id = 196
// module chunks = 1